import { Stop } from '../interfaces'

export const useAddresses = (stops?: Stop[]) => {
    const collection = stops && stops[0].address
    const delivery = stops && stops[stops.length - 1].address

    return { collection, delivery }
}
